<div class="d-flex justify-content-center mt-4">
    <div class="card ai-input-card shadow-lg">
        <div class="card-body d-flex align-items-center gap-2 p-2">
            <fa-icon [icon]="fa.faWandMagicSparkles" class="text-primary fs-5"></fa-icon>
            <input type="text" class="form-control border-0 shadow-none"
                placeholder="Ask AI to find what you're looking for..." [(ngModel)]="aiQuery"
                (keyup.enter)="onAiSubmit()" />
            <button class="btn btn-primary rounded-circle d-flex align-items-center justify-content-center"
                style="width: 36px; height: 36px;" (click)="onAiSubmit()">
                <fa-icon [icon]="fa.faArrowUp"></fa-icon>
            </button>
        </div>
    </div>
</div>

<div class="row g-3 mt-3">
    <div class="col-4">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">{{ assignment.name }}</h4>
                <div class="assignment-flags m-2 d-flex flex-wrap gap-1 justify-content-start z-3">
                    <span *ngFor="let organization of assignment.organizations"
                        class="rounded-circle overflow-hidden border border-white shadow-sm flex-shrink-0">
                        <img [src]="'assets/images/flags/' + organization.country_code + '.webp'" alt=""
                            class="assignment-flag-img">
                    </span>
                </div>
                <p>{{ assignment.description }}</p>
            </div>
        </div>
    </div>
    <div class="col-8">
        <div *ngIf="assignment" class="assignment-mosaic-outer">
            <div class="assignment-mosaic mosaic-bento rounded overflow-hidden" [attr.data-products]="productImageCount"
                [class.mosaic-hero-wide]="mosaicHeroWide">
                <figure class="mosaic-tile mosaic-main">
                    <span *ngIf="assignment.updating" class="mosaic-tile-spinner" aria-live="polite">
                        <span class="spinner-border spinner-border-sm text-light" role="status">
                            <span class="visually-hidden">Loading image</span>
                        </span>
                    </span>
                    <img [src]="assignment.picture" [alt]="assignment.name || ''">
                </figure>
                <figure *ngFor="let mapping of assignment.products" class="mosaic-tile mosaic-product">
                    <span *ngIf="mapping.product?.updating" class="mosaic-tile-spinner" aria-live="polite">
                        <span class="spinner-border spinner-border-sm text-light" role="status">
                            <span class="visually-hidden">Loading image</span>
                        </span>
                    </span>
                    <img [src]="mapping.product.picture" [alt]="mapping.product.name || ''">
                </figure>
            </div>
        </div>
    </div>
</div>